import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate, fmtTime, payLabel } from "@/lib/api";
import { StatusPill } from "@/components/StatusPill";

const TABS = ["Upcoming", "Past", "All"];

export default function PharmacyStaffing({ calendar = false }) {
  const [shifts, setShifts] = useState([]);
  const [tab, setTab] = useState("Upcoming");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/pharmacy/shifts");
      setShifts(data);
    })();
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const rows = shifts.filter((s) =>
    tab === "Upcoming" ? s.date >= today : tab === "Past" ? s.date < today : true
  );

  return (
    <div data-testid={calendar ? "pharmacy-calendar" : "pharmacy-staffing"}>
      <p className="overline">{calendar ? "Calendar" : "Staffing"}</p>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight sm:text-4xl">
        {calendar ? "My staffing calendar" : "All coverage"}
      </h1>

      <div className="mt-6 flex gap-2">
        {TABS.map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            data-testid={`tab-${t.toLowerCase()}`}
            className={`rounded-full px-4 py-2 text-sm transition-colors ${
              tab === t ? "bg-brand text-white" : "border border-slate-200 bg-white text-slate-600"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {rows.length === 0 ? (
        <p className="card-surface mt-8 p-8 text-sm text-slate-600" data-testid="staffing-empty">
          Nothing here yet.
        </p>
      ) : (
        <div className="card-surface mt-8 overflow-x-auto">
          <table className="w-full min-w-[820px] text-sm">
            <thead className="border-b border-slate-200 bg-slate-50/60 text-left">
              <tr className="[&>th]:px-5 [&>th]:py-3">
                <th className="overline">Date</th>
                <th className="overline">Role</th>
                <th className="overline">Worker</th>
                <th className="overline">Time</th>
                <th className="overline">Pay</th>
                <th className="overline">Interested</th>
                <th className="overline">Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.shift_id} className="border-b border-slate-100 last:border-0" data-testid={`staffing-row-${s.shift_id}`}>
                  <td className="px-5 py-4 font-medium">{fmtDate(s.date, { weekday: "short", month: "short", day: "numeric" })}</td>
                  <td className="px-5 py-4">{s.worker_role}</td>
                  <td className="px-5 py-4 text-slate-600">{s.confirmed_worker?.full_name || "—"}</td>
                  <td className="px-5 py-4">{fmtTime(s.start_time)} – {fmtTime(s.end_time)}</td>
                  <td className="px-5 py-4 font-display font-semibold">{payLabel(s)}</td>
                  <td className="px-5 py-4">{s.interest_count}</td>
                  <td className="px-5 py-4"><StatusPill status={s.status} /></td>
                  <td className="px-5 py-4">
                    <Link to={`/pharmacy/shifts/${s.shift_id}`} className="text-sm font-medium text-brand" data-testid={`staffing-view-${s.shift_id}`}>
                      Manage
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
